// BUILD-046 (Owner direction 2026-10-22): keeps a popover panel inside the window. The Presets panel is about 24rem wide and hangs from its button; on a narrow window the button can sit far
// enough to the right that the panel would run past the edge. `clampShift` says how far to move the panel sideways (negative: left, positive: right) so that it fits between two margins.
// A panel wider than the room is aligned to the left margin (its CSS max-width already keeps it within the window, so that case is only a fallback).
//
// Pure module: numbers in, a number out. Erasable TypeScript only.

/** The window edge margin, in pixels. */
export const POPOVER_MARGIN = 8;

/** The sideways move, in pixels, that puts a panel spanning [left, right] inside [margin, viewportWidth - margin]. 0 when it already fits. */
export function clampShift(left: number, right: number, viewportWidth: number, margin: number = POPOVER_MARGIN): number {
  if (![left, right, viewportWidth, margin].every((n) => Number.isFinite(n))) return 0;
  const room = viewportWidth - 2 * margin;
  if (room <= 0) return 0;
  if (right - left >= room) return margin - left;
  if (right > viewportWidth - margin) return viewportWidth - margin - right;
  if (left < margin) return margin - left;
  return 0;
}
